import { Button, CloseIcon, Link, Paragraph } from '@quickmd-llc/design-system';
import { Events, tracking } from '@lib';
import { useFilters } from './useFilters';
import { ProviderDetails } from '../';
import {
  Await,
  useLoaderData,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import dayjs from 'dayjs';
import { getVisitTypeUrlForPatient } from '@router/utils';
import { Availabilities } from '@types';
import { Suspense } from 'react';
import { Loader } from '@components';
import { AvailabilitiesLoader } from '@router/loaders/scheduleLoader';

export default function FilteredProvider(): JSX.Element | null {
  const { visitTypeId } = useParams();
  const { availabilities } = useLoaderData() as AvailabilitiesLoader;
  const { provider, showFilters, setProvider } = useFilters();
  const [searchParams, setSearchParams] = useSearchParams();
  const date = searchParams.get('date') || dayjs().format('YYYY-MM-DD');
  const providerId = searchParams.get('providerId');

  if (!provider) {
    return null;
  }

  function handleClearProvider() {
    setProvider(null);
    if (providerId) setSearchParams({ date: date }, { replace: true });
    tracking.trackEvent(Events.CLEAR_PROVIDER);
  }

  return (
    <Suspense fallback={<Loader />}>
      <Await resolve={availabilities}>
        {({ isSoonerProviderAvailable }: Availabilities) => {
          return (
            <div>
              {showFilters && (
                <Paragraph className="mb-2 font-semibold">
                  Search providers
                </Paragraph>
              )}
              <div className="mb-2 flex items-center justify-between rounded-lg bg-white p-4">
                <ProviderDetails provider={provider} isProviderFiltered />

                <Button
                  onClick={handleClearProvider}
                  size="s"
                  theme="warning"
                  isIcon
                >
                  <CloseIcon />
                </Button>
              </div>
              {providerId && isSoonerProviderAvailable && (
                <div className="flex justify-between">
                  Need something sooner?{' '}
                  <div>
                    <Link
                      to={getVisitTypeUrlForPatient(visitTypeId!)}
                      onClick={handleClearProvider}
                    >
                      View other providers
                    </Link>
                  </div>
                </div>
              )}
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
}
